<div class="dialog-container" role="dialog" aria-modal="true" aria-labelledby="add-doc-dialog-title">
  <div class="dialog-header">
    <div class="header-content">
      <div class="upload-icon">
        <img src="assets/images/cloudadd.svg" alt="Upload">
      </div>
      <div class="header-text">
        <h2 id="add-doc-dialog-title">{{ dialogMode === 'add' ? 'Add Documents' : 'Edit Document' }}</h2>
        <p *ngIf="dialogMode === 'add'">{{ currentStep === 1 ? 'Select and upload the documents of your choice' : 'Fill details of the selected document' }}</p>
      </div>
    </div>
    <button mat-icon-button (click)="onCancelDialog()" class="cancel-btn" aria-label="Close dialog">
      <img class="close-button" src="assets/images/close-circle.svg" alt="Upload">
    </button>
  </div>

  <div class="dialog-content" [class.upload-step]="dialogMode === 'add' && currentStep === 1">
    <form [formGroup]="documentForm">
      <!-- Step 1: Category Selection and File Upload (only for add mode) -->
      <ng-container *ngIf="dialogMode === 'add' && currentStep === 1">
        <!-- Modified layout to show category and document type side by side for identity documents -->
        <div class="category-row" [class.side-by-side]="isIdentitySelected">
          <div class="category-section">
            <h3>Choose Folders</h3>
            <mat-form-field appearance="outline" class="w-100">
              <mat-select formControlName="categories" multiple (selectionChange)="onCategorySelect($event)">
            
                <!-- Normal categories -->
                <mat-option *ngFor="let category of data.categories" [value]="category.id"
                  [disabled]="(isIdentitySelected && category.title !== 'Identity')">
                  {{category.title}}
                </mat-option>
            
                <!-- Divider (optional for better UX) -->
                <mat-divider></mat-divider>
            
                <!-- Special "Add New Category" option -->
                <!-- <mat-option *ngIf="!isIdentitySelected" class="add-category-option" (click)="openAddCategoryDialog()"
                  [disabled]="false">
                  + Add New Folders
                </mat-option> -->
                    
                <div class="add-category-option" (click)="openAddCategoryDialog()">
                  + Add New Folders
                </div>
              </mat-select>
            </mat-form-field>

          </div>

          <!-- Added document type selection for identity documents in Step 1 -->
          <div *ngIf="isIdentitySelected" class="category-section">
            <h3>Choose Document Type</h3>
            <mat-form-field appearance="outline" class="w-100" style="width: 55% !important;display:contents">
              <mat-select formControlName="documentType" (selectionChange)="check_doctype_exp($event)">
                <mat-option *ngFor="let type of doclist | keyvalue" [value]="type.key">
                  {{type.value}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="documentForm.get('documentType')?.hasError('required') && (documentForm.get('documentType')?.touched || documentForm.get('documentType')?.dirty)">Document Type is required</mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="section-title">Select Documents</div>
        
        <div class="upload-section" [class.has-files]="selectedFiles.length > 0">
          <div class="upload-area"
               [class.drag-over]="isDragOver"
               (click)="fileInput.click()"
               (drop)="onFileDropped($event)"
               (dragover)="onDragOver($event)"
               (dragleave)="onDragLeave($event)">
            <input
              #fileInput
              type="file"
              [multiple]="!isIdentitySelected"
              (change)="onFileSelected($event)"
              [accept]="isIdentitySelected ? identityAccept : generalAccept"
              hidden
            >
            <img src="assets/images/upBrowse.svg" alt="Upload" class="dropzone-icon">
            <p>Drag & drop files here</p>
            <button type="button" class="browse-link">Browse Files</button>
          </div>
        </div>

        <div *ngIf="selectedFiles.length > 0" class="selected-section">
          <div class="selected-header">
            <div class="selected-heading">Selected Files ({{ selectedFiles.length }})</div>
            <button type="button" class="clear-all-btn" (click)="clearAllFiles()">Clear All</button>
          </div>
          <div class="selected-files" #fileList>
            <div *ngFor="let file of selectedFiles; let i = index" class="file-card">
              <div class="file-left">
                <div class="file-icon-box">
                  <img src="assets/images/file.svg" alt="file" class="file-icon">
                </div>
                <div class="file-info">
                  <div class="file-name" [title]="file.name">{{ file.name }}</div>
                  <div class="file-size">{{ getFileSize(file) }}</div>
                  <!-- ✅ Progress bar now sits below size -->
                  <mat-progress-bar
                    mode="determinate"
                    [value]="uploadProgressList[i]?.progress"
                    class="progress-bar"
                    [ngClass]="{'completed': uploadProgressList[i]?.status === 'completed'}">
                  </mat-progress-bar>
                  <div class="status-text"
                       [ngClass]="{'completed': uploadProgressList[i]?.status === 'completed'}">
                    {{ uploadProgressList[i]?.status === 'completed'
                        ? '✔ Completed'
                        : uploadProgressList[i]?.progress + '% uploaded...' }}
                  </div>
                </div>
              </div>
              <button mat-icon-button (click)="removeFile(i)" class="delete-btn" aria-label="Remove file">
                <img src="assets/images/trash.svg" alt="trash">
              </button>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- Step 2: Document Details (for both add and edit modes) -->
      <!-- Added chosen category section for all Step 2 flows -->
      <ng-container *ngIf="(dialogMode === 'add' && currentStep === 2) || dialogMode === 'edit'">
        <!-- Modified layout to show category and document type side by side for identity documents -->
        <div class="category-row" [class.side-by-side]="isIdentitySelected">
          <div class="category-section">
            <h3>Chosen Folders</h3>
            <mat-form-field appearance="outline" class="w-100">
              <mat-select  formControlName="categories" multiple (selectionChange)="onCategorySelect($event)" 
                [disabled]="dialogMode === 'edit' && isIdentitySelected">
                <mat-option *ngFor="let category of data.categories" 
                          [value]="category.id"
                          [disabled]="isCategoryDisabled(category.id, category.title)">
                  {{category.title}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Positioned document type selection next to category selection for identity documents -->
          <div *ngIf="isIdentitySelected" class="category-section">
            <h3>Choosen Document Type</h3>
            <mat-form-field appearance="outline" class="w-100" style="width: 55% !important; display:contents">
              <mat-select  formControlName="documentType" (selectionChange)="check_doctype_exp($event)"
            [disabled]="isDocumentTypeDisabled()">
                <mat-option *ngFor="let type of doclist | keyvalue" [value]="type.key" #doctype_selected>
                  {{type.value}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="documentForm.get('documentType')?.hasError('required') && (documentForm.get('documentType')?.touched || documentForm.get('documentType')?.dirty)">Document Type is required</mat-error>
            </mat-form-field>
          </div>
        </div>

        <!-- Show selected documents section for all Step 2 flows -->
        <div class="section-title">Selected Documents</div>

        <div *ngIf="selectedFiles.length > 0" class="selected-files">
          <div *ngFor="let file of selectedFiles; let i = index" class="file-card">
            <div class="file-left">
              <div class="file-icon-box">
                <img src="assets/images/file.svg" alt="file" class="file-icon">
              </div>
              <div class="file-info">
                <div *ngIf="isIdentitySelected" class="file-name" [title]="file.name">{{ file.name }}</div>
                <div *ngIf="!isIdentitySelected" class="file-name" [title]="fileFormGroups[i].get('name')?.value">{{ fileFormGroups[i].get('name')?.value }}</div>
                <div class="file-size">{{ getFileSize(file) }}</div>
              </div>
            </div>
            <button mat-icon-button (click)="removeFile(i)" class="delete-btn" aria-label="Remove file">
              <img src="assets/images/trash.svg" alt="trash">
            </button>
          </div>
        </div>
      </ng-container>

      <!-- Identity Document Details for Step 2 -->
      <ng-container *ngIf="isIdentitySelected && dialogMode === 'add' && currentStep === 2">
        <!-- Added Document Details header for identity documents -->
        <div class="section-title">Document Details</div>
        <div class="document-details">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ docId }}</mat-label>
            <input matInput formControlName="documentId" maxlength="50" (keydown)="preventLeadingSpace($event)"  (input)="validateSpacesHome($event,'documentId')">
            <mat-hint align="end">{{documentForm.get('documentId')?.value?.length || 0}} / 50</mat-hint>
            <mat-error *ngIf="documentForm.get('documentId')?.hasError('required') && (documentForm.get('documentId')?.touched || documentForm.get('documentId')?.dirty)">{{docId}} is required</mat-error>
          </mat-form-field>

            <mat-form-field class="w-100" appearance="outline">
            <mat-label>Add Tags</mat-label>
            <mat-chip-grid #chipList>
              <mat-chip-row
                *ngFor="let tag of tags"
                [removable]="true"
                (removed)="removeTag(tag)">
                <span class="tag-text" [matTooltip]="tagTooltip(tag)" matTooltipClass="tag-tooltip" [matTooltipShowDelay]="200" matTooltipPosition="above">{{ truncateTag(tag) }}</span>
                <img class="removeicon"  matChipRemove src="assets/images/black-circle.svg" alt="cancel">
              </mat-chip-row>
              <input (keydown)="preventLeadingSpace($event)"  (input)="validateSpacesHome($event)"
                placeholder="New tag..."
                [matChipInputFor]="chipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="true"
                (matChipInputTokenEnd)="addTag($event)">
            </mat-chip-grid>
          </mat-form-field>
          
          <mat-form-field appearance="outline" class="w-100" *ngIf="chkexp">
            <mat-label>Expiration Date</mat-label>
            <input matInput readonly [matDatepicker]="picker" formControlName="expirationDate" [min]="minDate" (focus)="picker.open()" (click)="picker.open()" />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error *ngIf="documentForm.get('expirationDate')?.hasError('required') && (documentForm.get('expirationDate')?.touched || documentForm.get('expirationDate')?.dirty)">Expiration Date is required</mat-error>
            <mat-error *ngIf="documentForm.get('expirationDate')?.hasError('expirationTooSoon') && (documentForm.get('expirationDate')?.touched || documentForm.get('expirationDate')?.dirty)">
              Expiration Date must be after today
            </mat-error>
          </mat-form-field>
        </div>
      </ng-container>

      <!-- Edit Mode Document Details -->
      <ng-container *ngIf="dialogMode === 'edit' && currentStep === 2">
        <div class="document-details">
          <!-- Identity Document fields -->
          <ng-container *ngIf="isIdentitySelected">
            <!-- <mat-form-field appearance="outline" class='disabled-field' class="w-100" >
              <mat-label>Document Type</mat-label>
              <mat-select [disabled]="true" formControlName="documentType" >
                <mat-option *ngFor="let type of doclist | keyvalue" [value]="type.key" >
                  {{type.value}}
                </mat-option>
              </mat-select>
            </mat-form-field> -->

            <mat-form-field *ngIf="isIdentitySelected" appearance="outline" class="w-100">
              <mat-label>{{ docId }}</mat-label>
              <input matInput formControlName="documentId" required>
            </mat-form-field>

          </ng-container>
          <mat-form-field *ngIf="!isIdentitySelected" appearance="outline" class="w-100">
            <mat-label>Document Name</mat-label>
            <input matInput formControlName="name" maxlength="30" (input)="onNameInput()">
            <mat-hint align="end">{{documentForm.get('name')?.value?.length || 0}} / 30</mat-hint>
            <mat-error *ngIf="documentForm.get('name')?.hasError('required') && (documentForm.get('name')?.touched || documentForm.get('name')?.dirty)">Document Name is required</mat-error>
            <mat-error *ngIf="documentForm.get('name')?.hasError('maxlength')">Maximum 30 characters allowed</mat-error>
            <mat-error *ngIf="documentForm.get('name')?.hasError('duplicateName')">A document with this name already exists</mat-error>
            <!-- <mat-error *ngIf="documentForm.get('name')?.hasError('whitespace')">
  Document Name cannot be empty or spaces only
</mat-error> -->

          </mat-form-field>
          
          <mat-form-field *ngIf="!isIdentitySelected" appearance="outline" class="w-100">
            <mat-label>Description</mat-label>
            <textarea matInput formControlName="description" rows="3" maxlength="500"></textarea>
            <mat-hint align="end">{{documentForm.get('description')?.value?.length || 0}} / 500</mat-hint>
            <mat-error *ngIf="documentForm.get('description')?.hasError('required') && (documentForm.get('description')?.touched || documentForm.get('description')?.dirty)">Description is required</mat-error>
            <mat-error *ngIf="documentForm.get('description')?.hasError('maxlength')">Maximum 500 characters allowed</mat-error>
            <!-- <mat-error *ngIf="documentForm.get('description')?.hasError('whitespace')">
  Description cannot be empty or spaces only
</mat-error> -->

          </mat-form-field>
          
            <mat-form-field class="w-100" appearance="outline">
            <mat-label>Add Tags</mat-label>
            <mat-chip-grid #chipList>
              <mat-chip-row
                *ngFor="let tag of tags"
                [removable]="true"
                (removed)="removeTag(tag)">
                <span class="tag-text" [matTooltip]="tagTooltip(tag)" matTooltipClass="tag-tooltip" [matTooltipShowDelay]="200" matTooltipPosition="above">{{ truncateTag(tag) }}</span>
                <img class="removeicon"  matChipRemove src="assets/images/black-circle.svg" alt="cancel">
              </mat-chip-row>
              <input
                placeholder="New tag..."
                [matChipInputFor]="chipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="true"
                (matChipInputTokenEnd)="addTag($event)">
            </mat-chip-grid>
                <mat-error *ngIf="documentForm.get('tags')?.errors?.['serverError']">
                  Tag is required
                </mat-error>
          </mat-form-field>
                  
          <!-- Expiration Date only for passport & driver_license -->
            <mat-form-field *ngIf="chkexp" appearance="outline" class="w-100">
              <mat-label>Expiration Date</mat-label>
              <input matInput readonly [matDatepicker]="picker" formControlName="expirationDate" [min]="minDate"
                    (focus)="picker.open()" (click)="picker.open()">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              <mat-error *ngIf="documentForm.get('expirationDate')?.hasError('expirationTooSoon') 
                              && (documentForm.get('expirationDate')?.touched || documentForm.get('expirationDate')?.dirty)">
                Expiration Date must be after today
              </mat-error>
            </mat-form-field>

          <mat-form-field *ngIf="!isIdentitySelected" appearance="outline" class="w-100" >
            <mat-label>Expiration Date</mat-label>
            <input matInput readonly [matDatepicker]="picker" formControlName="expirationDate" [min]="minDate" (focus)="picker.open()" (click)="picker.open()">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          
            <mat-error *ngIf="documentForm.get('expirationDate')?.hasError('expirationTooSoon') && (documentForm.get('expirationDate')?.touched || documentForm.get('expirationDate')?.dirty)">
              Expiration Date must be after today
            </mat-error>
          </mat-form-field>
        </div>
      </ng-container>

      <!-- Multi-document upload accordion layout for non-identity documents -->
      <ng-container *ngIf="!isIdentitySelected && dialogMode === 'add' && currentStep === 2">
        <div class="section-title">Document Details</div>
        <div class="document-details">
          <mat-accordion>
            <mat-expansion-panel *ngFor="let fileForm of fileFormGroups; let i = index" [formGroup]="fileForm" [expanded]="true">
              <mat-expansion-panel-header>
                <mat-panel-title> 
                  <div 
                      [ngClass]="fileForm.invalid ? 'alert-panel' : 'text-nom'">
                      {{ fileFormGroups[i].get('name')?.value }}
                    </div>
                 
                </mat-panel-title>

                <!-- <mat-panel-description> -->
                  <!-- <button mat-icon-button (click)="removeFile(i)" class="delete-btn">
                    <img src="assets/images/trash.svg" alt="trash">
                  </button> -->
                <!-- </mat-panel-description> -->
              </mat-expansion-panel-header>

              <div class="file-form-container">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Document Name </mat-label>
                  <input matInput formControlName="name" maxlength="30" (input)="onNameInput(i)"  (keydown)="preventLeadingSpace($event)"  (input)="validateSpacesHome($event,'name')">
                  <mat-hint align="end">{{fileForm.get('name')?.value?.length || 0}} / 30</mat-hint>
                  <mat-error *ngIf="fileForm.get('name')?.hasError('required') && (fileForm.get('name')?.touched || fileForm.get('name')?.dirty)">Document Name is required</mat-error>
                  <mat-error *ngIf="fileForm.get('name')?.hasError('maxlength')">Maximum 30 characters allowed</mat-error>
                  <mat-error *ngIf="fileForm.get('name')?.hasError('duplicateName')">A document with this name already exists</mat-error>
                  <!-- <mat-error *ngIf="documentForm.get('name')?.hasError('whitespace')">
  Document Name cannot be empty or spaces only
</mat-error> -->

                </mat-form-field>

                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Description</mat-label>
                  <textarea matInput formControlName="description" rows="3" maxlength="500"  (keydown)="preventLeadingSpace($event)"  (input)="validateSpacesHome($event,'description')"></textarea>
                  <mat-hint align="end">{{fileForm.get('description')?.value?.length || 0}} / 500</mat-hint>
                  <mat-error *ngIf="fileForm.get('description')?.hasError('required') && (fileForm.get('description')?.touched || fileForm.get('description')?.dirty)">Description is required</mat-error>
                  <mat-error *ngIf="fileForm.get('description')?.hasError('maxlength')">Maximum 500 characters allowed</mat-error>
                  <!-- <mat-error *ngIf="documentForm.get('description')?.hasError('whitespace')">
  Description cannot be empty or spaces only
</mat-error> -->

                </mat-form-field>

                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Add Tags</mat-label>
                  <mat-chip-grid #dynamicChipList>
                    <mat-chip-row
                      *ngFor="let tag of fileForm.get('tags')?.value"
                      [removable]="true"
                      (removed)="removeTagFromForm(i, tag)">
                      <span class="tag-text" [matTooltip]="tagTooltip(tag)" matTooltipClass="tag-tooltip" [matTooltipShowDelay]="200" matTooltipPosition="above">{{ truncateTag(tag) }}</span><img class="removeicon"  matChipRemove src="assets/images/black-circle.svg" alt="cancel">
                    </mat-chip-row>
                    <input  (keydown)="preventLeadingSpace($event)"  (input)="validateSpacesHome($event)"
                      placeholder="Add Tag"
                      [matChipInputFor]="dynamicChipList"
                      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                      [matChipInputAddOnBlur]="true"
                      (matChipInputTokenEnd)="addTagToForm($event,i)">
                  </mat-chip-grid>
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Expiration Date</mat-label>
                  <input matInput readonly [matDatepicker]="picker" formControlName="expirationDate" [min]="minDate" (focus)="picker.open()" (click)="picker.open()" />
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                
                  <mat-error *ngIf="documentForm.get('expirationDate')?.hasError('expirationTooSoon') && (documentForm.get('expirationDate')?.touched || documentForm.get('expirationDate')?.dirty)">
                    Expiration Date must be after today
                  </mat-error>
                </mat-form-field>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </ng-container>

    </form>
  </div>

  <div class="dialog-actions">
    <button class="btn-cancel" (click)="onCancel()">
      Cancel
    </button>

    <!-- Added document type validation for identity documents in Next button disabled condition -->
    <button *ngIf="dialogMode === 'add' && currentStep === 1"
            class="btn-primary"
            [disabled]="isUploading || (isIdentitySelected ? (selectedFiles.length === 0 || !documentForm.get('documentType')?.value) : fileForms.length === 0)"
            (click)="moveToNextStep()">
      Next
    </button>

    <button *ngIf="dialogMode === 'edit' || currentStep === 2"
            class="btn-primary"
             [disabled]="isUploading || (isIdentitySelected ? documentForm.invalid : fileForms.invalid)"
            (click)="moveToNextStep()">
      Save
    </button>
  </div>

</div>
<!-- Fullscreen loader (only shows on Step 2 when uploading) -->
<div class="upload-overlay" *ngIf="isUploading && currentStep === 2">
  <div class="logo-spinner">
    <img src="assets/images/vita-logo.png" alt="Loading..." />
  </div>
</div>